import SMHSDK from './packages/smh';
import * as SMH from './typings';
import { AccessTokenManager, WeakAccessTokenManager } from './packages/access-token-manager';
import getHTTP from './packages/http';

export default SMHSDK;
export { SMH, AccessTokenManager, WeakAccessTokenManager, getHTTP };
